<template>
  <div class="research">
    <h1
      v-bg-typography="'h1'"
      :style="{ marginTop: '10px', 'margin-bottom': '30px' }"
    >
      Participants
    </h1>

    <List
      :headers="list.headers"
      :values="list.values"
      :actions="list.actions"
      :data="participants"
      :fractions="list.fractions"
      :genderIcons="list.genderIcons"
      @change="getChanges"
    />
    <bg-loader :dark="true" v-if="isLoading"></bg-loader>
    <bg-modal
      v-if="isModalOpen"
      body="Are you sure you want to remove this participant?"
      @close="isModalOpen = false"
    >
      <bg-loader :dark="true" v-if="isDeleting"></bg-loader>
      <bg-button
        variant="secondary"
        text="Cancel"
        @click="isModalOpen = false"
      />
      <bg-button
        variant="destructive"
        class="action"
        text="Delete"
        @click="deleteParticipant"
      />
    </bg-modal>
  </div>
</template>

<style scoped>
.bg-list-container {
  margin-top: 20px;
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";
import BgModal from "@/components/bg-modal";
import BgButton from "@/components/bg-button";
import BgLoader from "@/components/bg-loader";
import moment from "moment";
import API from "@/api";
import { mapState } from "vuex";
import List from "@/components/list";
export default {
  name: "researchTest",
  components: {
    BgModal,
    BgButton,
    BgLoader,
    List,
  },
  directives: {
    BgTypography,
  },
  computed: {
    ...mapState({
      testState: (state) => state.test,
    }),
    showMessage: function() {
      if (this.platform === "video" && !this.processed) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    getChanges(val) {
      if (val.action === "Select") {
        const testId = this.$route.params.id;
        this.$router.push(
          `/research/test/${testId}/participants/${val.item.id}`
        );
      } else if (val.action === "Delete") {
        this.isModalOpen = true;
        this.participantDelete = val.item.id;
      }
    },
    timeToComplete(p) {
      const startTime = moment(p.started_at);
      const endTime = moment(p.ended_at);
      const diff = endTime.diff(startTime);
      return moment(diff).format("mm:ss");
    },
    async deleteParticipant() {
      this.isDeleting = true;
      const id = this.$route.params.id;
      const participantId = this.participantDelete;
      await API.test.deleteParticipant(id, participantId);
      this.mapParticipants();
      this.isDeleting = false;
      this.isModalOpen = false;
    },
    async mapParticipants() {
      const res = await API.test.getTest(this.$route.params.id);
      this.isLoading = false;
      this.platform = res.platform;
      res.participants.forEach((el) => {
        if (el.type === "video_heatmap") {
          this.processed = true;
        }
      });
      const withTtc = res.participants
        .map((p) => {
          return {
            ...p,
            ...p.demographic,
            time_to_complete: this.timeToComplete(p),
            link: `/research/test/${this.$route.params.id}/participants/${
              p.id
            }`,
          };
        })
        .filter((p) => p.type === "default");
      this.participants = withTtc;
    },
  },
  data() {
    return {
      data: null,
      participants: [],
      isLoading: true,
      animate: true,
      isModalOpen: false,
      isDeleting: false,
      headers: [
        {
          value: "id",
          icon: "account",
          format: (value) => `Participant ${value}`,
        },
        {
          value: "age",
          label: "Age",
        },
        {
          value: "gender",
          label: "Gender",
          format: (value) => value.replace(/^\w/, (c) => c.toUpperCase()),
        },
        {
          value: "education",
          label: "Education",
        },
        {
          label: "Time to complete",
          value: "time_to_complete",
        },
        {
          label: "Questionnaire",
          value: "answers",
        },
      ],
      actions: [
        {
          type: "video",
          text: "View",
        },
      ],
      list: {
        headers: [
          "Participant",
          "Gender",
          "Age",
          "Education",
          "Time to complete",
        ],
        values: [
          "Participant :id",
          "gender",
          "age",
          "education",
          "time_to_complete",
        ],
        actions: ["Delete"],
        fractions: [1, 1, 1, 1, 1],
        genderIcons: true,
      },
      participantDelete: null,
      platform: "",
      processed: false,
    };
  },

  mounted() {
    this.mapParticipants();
  },
};
</script>
